module.exports = __webpack_public_path__ + "files/643f7ee642bdd00eb669eafb36177d55.png";